import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol viewBox=\"0 0 30 31\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete\"><path d=\"M2.566 6.85H1.43C.64 6.85 0 6.237 0 5.48c0-.758.64-1.371 1.43-1.371h27.14c.79 0 1.43.613 1.43 1.37 0 .758-.643 1.371-1.433 1.371h-1.138v15.904a8 8 0 0 1-8 8H10.57a8 8 0 0 1-8-8V6.867a.855.855 0 0 1-.005-.017zm22.291 0H5.143v16.335a5 5 0 0 0 5 5h9.714a5 5 0 0 0 5-5V6.85zm-7.899 13.768v-6.079c0-.56.576-1.014 1.286-1.014.71 0 1.286.454 1.286 1.014v6.079c-.003.56-.578 1.013-1.286 1.013-.71 0-1.286-.453-1.286-1.013zm-5.425 1.013c-.71 0-1.286-.453-1.286-1.013v-6.079c0-.56.576-1.014 1.286-1.014.71 0 1.286.454 1.286 1.014v6.079c0 .56-.575 1.013-1.286 1.013zM18.301 2.57h-6.71c-.743 0-1.344-.574-1.344-1.284 0-.71.601-1.285 1.343-1.285h6.708c.742 0 1.343.575 1.343 1.285s-.6 1.284-1.34 1.284z\" fill=\"#777\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/delete.svg
// module id = eXS7
// module chunks = 28